import * as actions from '../../actions/ui';

import { initialState } from './initialState';

export { initialState };

export const uiState = (state = initialState, action) => {
    let images = [];
    let pos = 0;
    switch (action.type) {
        case actions.UI_CLEAR:
            return { ...initialState };
        case actions.UI_PRISM_MENU:
            return { ...state, prismMenu: action.payload };
        case actions.UI_PRISM_MENU_STATS:
            return { ...state, prismMenuStats: action.payload };
        case actions.UI_PRISM_MULTI_COLUMN:
            return { ...state, prismMultiColumn: action.payload };
        case actions.UI_SET_MODAL_PICKER_SHOW_CLEAR:
            return { ...state, modalPickerShowClear: action.payload };
        case actions.UI_SET_MODAL_PICKER_SHOW_CLEAR_COUNT:
            return { ...state, modalPickerShowClearCount: action.payload };
        case actions.UI_TEAM_PAGE:
            return { ...state, teamPage: action.payload };
        case actions.UI_VIDEO_TIME:
            return { ...state, videoTime: action.payload };
        case actions.UI_VIDEO:
            pos = action.payload;
            pos = pos === 0 ? pos + 0.05 : pos;
            pos = pos === state.videoPosition ? pos + 0.1 : pos;
            return {
                ...state,
                videoPosition: parseInt(pos, 10),
            };
        case actions.UI_SAVING:
            return { ...state, saving: action.payload };
        case actions.UI_ENABLED:
            return { ...state, enabled: action.payload };
        case actions.UI_HAS_CRM_METRICS:
            return { ...state, hasCRMMetrics: action.payload };
        case actions.UI_TOGGLE_LEFT_ASIDE:
            return { ...state, leftAsideOpen: action.payload };
        case actions.UI_TOGGLE_RIGHT_ASIDE:
            return { ...state, rightAsideOpen: !state.rightAsideOpen };
        case actions.UI_TOGGLE_EXPLORE_ASIDE:
            return { ...state, exploreAsideOpen: action.payload };
        case actions.UI_TOGGLE_FILTER_ASIDE:
            return { ...state, filterAsideOpen: action.payload };
        case actions.UI_SET_ASIDE_FILTERS:
            return { ...state, asideFilters: action.payload };
        case actions.UI_CLEAR_ASIDE_FILTER_VALUES: {
            const temp = [...state.asideFilters];
            temp.forEach(x => {
                x.value = null;
            });

            return { ...state, asideFilters: temp };
        }
        case actions.UI_SET_ASIDE_FILTER_VALUE:
            const { property, value } = action.payload;
            const temp = [...state.asideFilters];
            const filter = temp.find(x => x.property === property);
            if (filter) {
                filter.value = value;
            }

            return { ...state, asideFilters: temp };
        case actions.UI_SET_PICKER_FILTERS:
            return { ...state, pickerFilters: action.payload };
        case actions.UI_CLEAR_PICKER_FILTER_VALUES: {
            const temp = [...state.pickerFilters];
            temp.forEach(x => {
                x.value = null;
            });

            return { ...state, pickerFilters: temp };
        }
        case actions.UI_SET_PICKER_FILTER_VALUE:
            const pickerTemp = [...state.pickerFilters];
            const pickerFilter = pickerTemp.find(x => x.property === action.payload.property);
            if (pickerFilter) {
                pickerFilter.value = action.payload.value;
            }

            return { ...state, pickerFilters: pickerTemp };
        case actions.UI_TOGGLE_RIGHT_ASIDE_PANEL:
            return { ...state, rightAsideTab: action.payload };
        case actions.UI_TOGGLE_LEFT_ASIDE_MENU:
            return { ...state, leftAsideMenusOpen: returnNewMenuState(state.leftAsideMenusOpen, action.payload) };
        case actions.UI_HANDLES_LOADED:
            return { ...state, handles: action.payload };
        case actions.UI_TAGS_LOADED:
            return { ...state, tags: action.payload.map(t => t.name) };
        case actions.UI_TEXT_LOADED:
            document.TRANSLATIONS = action.payload;
            return { ...state, text: action.payload };
        case actions.UI_GOALS_UPDATED:
            return { ...state, goalsUpdated: new Date() };
        case actions.UI_CUSTOM_TEXT_LOADED:
            return { ...state, customText: action.payload };
        case actions.UI_CLEAR_IMAGE:
            return { ...state, images: [...state.images].filter(i => i.file !== action.payload.file) };
        case actions.UI_ADD_IMAGE:
            images = [
                ...state.images
                    .filter(i => `${i.folder}/${i.file}` !== `${action.payload.folder}/${action.payload.file}`)
                    .concat([action.payload]),
            ];

            return { ...state, images };
        case actions.UI_SHOW_SUCCESS:
            return { ...state, showSuccess: action.payload };
        case actions.UI_SET_FORM_HELP:
            return { ...state, showFormHelp: action.payload };
        case actions.UI_SET_DASHBOARD_LOCKED:
            return { ...state, dashboardLocked: action.payload };
        case actions.UI_WIDGET_CONFIG:
            return { ...state, filterWidget: action.payload };
        default:
            return state;
    }
};

const returnNewMenuState = (currentState, toggled) => {
    const result = new Array(currentState.length > toggled ? currentState.length : toggled);
    result[toggled] = !currentState[toggled];
    return result;
};
